import React from "react";
import "./component-css/LearningMaterials.css";

const RiskManagement = () => {
    const materials = [
        {
            title: "A Risk Assessment Framework for Land Use Planning",
            type: "pdf",
            link: "/materials/risk-management/LUND_english.pdf",
            description:
                "An overview of the basics: introduction, background, and how to identify what assets are most valuable in planning."
        },
        {
            title: "Basics of Disaster Risk and Hazard Assessment",
            type: "pdf",
            link: "/materials/risk-management/UNS_English.pdf",
            description:
                "A short introduction to the main types of hazards and risks, including how vulnerability, exposure, and coping capacity shape overall disaster risk."
        },
        {
            title: "Preparedness and Planning",
            type: "youtube",
            link: "https://www.youtube.com/watch?v=iBt-9XpdDJY",
            description:
                "An overview of preparedness strategies and planning approaches for managing risks and strengthening the resilience of communities facing climate-related challenges."
        },
        {
            title: "An Introduction to Adaptive Capacity",
            type: "youtube",
            link: "https://www.youtube.com/watch?v=_66VjHNF2ag",
            description:
                "A brief introduction to adaptive capacity and how it helps communities strengthen resilience to climate-related risks and changes."
        },
        {
            title: "An Introduction to Perspectives of Resilience",
            type: "youtube",
            link: "https://www.youtube.com/watch?v=Sn0YJZSIa5Y",
            description:
                "A brief introduction to different perspectives of resilience and how they help communities respond to climate-related challenges and risks."
        },
        {
            title: "Uncertainties and Robust Decision Making",
            type: "youtube",
            link: "https://www.youtube.com/watch?v=cNiAvXX5t9o",
            description:
                "An introduction to managing uncertainties and applying robust decision-making approaches for planning and risk management."
        },
        {
            title: "Hazard Mapping and Risk Assessment-Building Fires",
            type: "youtube",
            link: "https://youtu.be/Hbimdqo150o",
            description:
                "An overview of hazard mapping and risk assessment methods focused on identifying and managing risks related to building fires."
        },
        {
            title: "Social Resilience to Hazards: The Role of Insurance and Disaster Risk Management",
            type: "youtube",
            link: "https://youtu.be/nDx_hyIAnSc",
            description:
                "An overview of how insurance and disaster risk management contribute to strengthening social resilience to hazards."
        },
        {
            title: "Climate Change-Impact in Bosnia and Herzegovina",
            type: "youtube",
            link: "https://youtu.be/AtBzDEe92XU",
            description:
                "An overview of how insurance and disaster risk management contribute to strengthening social resilience to hazards."
        },
        {
            title: "Importance of Health and Safety at Work for Sustainability",
            type: "youtube",
            link: "https://youtu.be/D7wMZPFup1U",
            description:
                "An overview of the role of occupational health and safety in supporting sustainable and safe working environments."
        },
        {
            title: "Risk Assessment and Vulnerability Assessment and Estimation",
            type: "youtube",
            link: "https://youtu.be/OUfYIE1cAA0",
            description:
                "Overview of methods for assessing risks and vulnerabilities to support decision-making and resilience planning."
        },
        {
            title: "Post-Disaster Needs Assessment: Legal Perspective (Albania Earthquake 2019 Case)",
            type: "youtube",
            link: "https://youtu.be/V_Sxtw1yU4U",
            description:
                "Examines post-disaster needs assessment from a legal perspective, based on the 2019 Albania earthquake case."
        },
        {
            title: "Force Majeure and FIDIC Contracts in Construction",
            type: "youtube",
            link: "https://youtu.be/WDF6M8cBGHo",
            description:
                "Explores force majeure and changing conditions in construction contracts under FIDIC frameworks."
        },
        {
            title: "Risks in Construction Contracts",
            type: "youtube",
            link: "https://youtu.be/eaQyyibpJM8",
            description:
                "Overview of risks and uncertainties in construction projects and contract implementation."
        },
        {
            title: "FIDIC Claims Procedures in Construction",
            type: "youtube",
            link: "https://youtu.be/WvMc3UmNbyA",
            description:
                "Overview of claim procedures and dispute handling under FIDIC construction contracts."
        }
    ];

    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Risk Management Learning Materials</h1>
                <p className="lm-subtitle">
                    Curated guides and videos on assessing hazards, understanding
                    vulnerability, and building resilient, well-planned communities.
                </p>
            </header>

            <div className="lm-list">
                {materials.map((m, index) => (
                    <div key={index} className="lm-card">
                        <h3 className="lm-card-title">{m.title}</h3>

                        <p className="lm-card-desc">{m.description}</p>

                        <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lm-card-link"
                        >
                            {m.type === "pdf" ? "📄 Open PDF" : "▶ Watch Video"}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RiskManagement;
